export const IS_CAPTURE_SUPPORTED = (() => {
  const i = document.createElement('input')
  i.setAttribute('capture', 'true')
  return Boolean(i.capture)
})()

export const ERROR_FILE_TOO_BIG = 'error.file-too-big'
export const ERROR_FILE_FORMAT = 'error.file-format'
export const ERROR_TOO_MANY_FILES = 'error.too-many-files'
export type BUploadErrorCode =
  | typeof ERROR_FILE_TOO_BIG
  | typeof ERROR_FILE_FORMAT
  | typeof ERROR_TOO_MANY_FILES
